import axios from "axios";
import { createHeaders } from "./Constant";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-vkyc.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // prod
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // test 
  "customer-vkyc-stage.finhub.habilelabs.io": "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc",  // stage
};

const baseURL = isLocal
  ? "http://localhost:8000/api/v1/vkyc"
  : baseMap[hostname] || "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc";

export const geolocationService = {
  async checkUserLocation() {
    try {
      const response = await axios.get(
        `${baseURL}/ip-geolocation/check`,
        { headers: createHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Geolocation check failed:", error);
      throw error;
    }
  },
};